'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'person-carry-box';
var width = 384;
var height = 512;
var aliases = ["person-carry"];
var unicode = 'f4cf';
var svgPathData = 'M120 24A56 56 0 1 0 8 24 56 56 0 1 0 120 24zM59.1 112C26.5 112 0 138.5 0 171.1L0 272c0 30.2 14.2 58.7 38.4 76.8l76.8 57.6c8.1 6 12.8 15.5 12.8 25.6l0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80c0-30.2-14.2-58.7-38.4-76.8l-41.6-31.2 0-80.1 2.8 3.9c18 25.2 47.1 40.2 78.1 40.2L352 288c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L224 96c-17.7 0-32 14.3-32 32l0 96c-10-.3-19.3-5.2-25.1-13.4l-48.7-68.2C104.6 123.3 82.5 112 59.1 112zM0 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-84-54.4-40.8c-3.3-2.5-6.5-5.1-9.6-7.9L0 512z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonCarryBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;